__turbopack_context__.v({
  "className": "roboto_20989dc1-module__WZGeGG__className",
});
